import CollecPackage from './CollecPackage'
import MyPackage from './MyPackage'
import BuyPackage from './BuyPackage'

export default {
  CollecPackage, MyPackage, BuyPackage
}



// WEBPACK FOOTER //
// ./src/components/Package/index.js